import React, { useState, useEffect } from 'react';
import {
  Checkbox,
  Box,
  Button,
  InputBase,
  Typography,
  ThemeProvider,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  SxProps, Theme,Tooltip
} from '@mui/material';
import { pink } from '@mui/material/colors';
import BasicTable, { Column } from '../../components/table';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import getTheme from '../../theme/theme';
import { BASEURL } from '../../constants/Common';
import axios from 'axios';
import { Projects } from './ProjectInterfaces';
import { toast } from 'react-toastify';
import { Backdrop, CircularProgress } from '@mui/material';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import { OrganizationFinal } from '../../pages/subscriptionplans/Subscription';

interface WorkweekHoliday {
  id: number;
  work_week: string;
  holiday_date: string;
  holiday_label: string;
}

interface HolidayData {
  label: string;
  date: string;
}

interface Employee {
  username: string;
}

interface Contractor {
  username: string;
}

interface Holiday {
  from: string;
  to: string;
  label: string;
}

const ProjectSchedule = () => {
  const [projectData, setProjectData] = useState<Projects[]>([]);
  const [filteredProject, setFilteredProject] = useState<Projects[]>([]);
  const [workingHolidaystable, setWorkingHolidaystable] = useState<
    HolidayData[]
  >([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const navigate = useNavigate();
  const selectedProjectTitle = useSelector(
    (state: RootState) => state.project.selectedProjectTitle
  );
  const [selProjects, setSelProjects] = useState<Projects[]>([]);
  const [workdaydata, setWorkdayData] = useState<WorkweekHoliday[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [empNames, setEmpNames] = useState<Employee[]>([]);
  const [names, setNames] = useState<string[]>([]);
  const [contractornames, contractorSetNames] = useState<string[]>([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showTextFields, setShowTextFields] = useState(false);
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [holidayDates, setHolidayDates] = useState<Holiday[]>([]);
  const [holidaysRows, setHolidaysRows] = useState<
    { label: string; date: Date | null }[]
  >([]);
 const [organizationFinal, setOrganizationFinal] = useState<OrganizationFinal | null>(null);
  const orgid = localStorage.getItem('orgid');
  const Admindata = localStorage.getItem('userRoleAdmin');
  const userraccess = JSON.parse('' + localStorage.getItem('userrole'));
  const scheduleAccess = userraccess?.scheduleaccess;
  // const subscriptionstatus = localStorage.getItem('subscriptionstatus');
  const theme = getTheme();
  let UserroleAdmin: any = null;

  if (Admindata) {
    UserroleAdmin = JSON.parse(Admindata);
  } else {
    console.log('No data found in localStorage');
  }

  const [userRole, setUserRole] = useState<string>(UserroleAdmin);
    const userid = localStorage.getItem('userid');

  useEffect(() => {
    // Fetch project data and set it to state
    fetchProjectDetails();
    fetchOrganization();
  }, []);

   const fetchOrganization = async () => {
     try {
       const response = await axios.get(`${BASEURL}/organization/${orgid}/`, {
         headers: { Accept: 'application/json' },
       });
       setOrganizationFinal(response.data);
     } catch (error) {
       console.error('Error fetching organization:', error);
     }
   };


  useEffect(() => {
    // Filter project based on title when search term changes
    if (selectedProjectTitle == '0') {
      setFilteredProject(
        projectData.filter(
          (pd: Projects) => pd.id + '' !== selectedProjectTitle
        )
      );
    } else {
      setFilteredProject(
        projectData.filter(
          (pd: Projects) => pd.id === parseInt(selectedProjectTitle)
        )
      );
    }
  }, [searchTerm, selectedProjectTitle]);

  useEffect(() => {
    //Filter project data based on title when search term changes
    setFilteredProject(
      projectData.filter(
        (pd) =>
          pd.project_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pd.project_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pd.project_manager.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pd.project_status.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pd.project_start_date.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm]);

  //Fetch the workweek days and holidays from the db.
  const fetchWorkingdaysandHolidays = async () => {
    try {
      const workingdays = `${BASEURL}/workweek-holidays/`;
      const response = await axios.get(workingdays, {
        headers: { Accept: 'application/json' },
      });

      const workingandholidaysdata = response.data;

      localStorage.setItem(
        'workingandholidaysdata',
        JSON.stringify(workingandholidaysdata)
      );

      if (!orgid) {
        return; // Return early or handle this case as needed
      }
      // Convert orgid to integer if necessary
      const orgidNumber = parseInt(orgid, 10);

      // Filter based on orgid
      const filteredData = workingandholidaysdata.filter(
        (entry: any) => entry.holidaytracking_orgid === orgidNumber
      );

      
      // If there's no filtered data, return early
      if (filteredData.length === 0) {
        setSelectedDays(['Monday', 'Tuesday','Wednesday','Thursday','Friday']);
        setWorkingHolidaystable([]); // Clear the table if no data is found
        // setSelectedDays([]); // Clear selected days if no data is found
        return;
      }
      setWorkdayData(filteredData);
      const workWeeks = filteredData.map((entry: any) => entry.work_week);

      if (filteredData.length > 0) {
        let allHolidayLabels: string[] = [];
        let allHolidayDates: string[] = [];

        filteredData.forEach((entry: any) => {
          const holidayDates = entry.holiday_date.split(',');
          const holidayLabels = entry.holiday_label.split(',');

          allHolidayLabels = [...allHolidayLabels, ...holidayLabels];
          allHolidayDates = [...allHolidayDates, ...holidayDates];
        });

        const holidaysData = allHolidayLabels.map((label, index) => ({
          label: label,
          date: allHolidayDates[index],
        }));

        setWorkingHolidaystable(holidaysData);
      }

      // Assuming you only want the first entry or single work_week data
      if (workWeeks.length > 0) {
        const workWeekArray = workWeeks[0].split(',');
        setSelectedDays(workWeekArray); // Set the work week days in state
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatDate1 = (dateString: any) => {
    const [year, month, day] = dateString.split('-');
    return `${month}-${day}-${year}`;
  };

  useEffect(() => {
    if (workdaydata.length > 0) {
      const { holiday_date, holiday_label } = workdaydata[0];

      const holidayDatesArray = holiday_date.split(',');
      const holidayLabelsArray = holiday_label.split(',');

      const formattedHolidayDates = holidayDatesArray.map((date, index) => ({
        from: formatDate1(date),
        to: formatDate1(date),
        label: holidayLabelsArray[index],
      }));
      setHolidayDates(formattedHolidayDates);
    } else {
      console.error('No workweekdays data found.');
    }
  }, [workdaydata]); // useEffect runs when workdaydata changes

  useEffect(() => {
    const formattedHolidayDates = workingHolidaystable.map((row) => ({
      from: formatDate1(row.date),
      to: formatDate1(row.date),
      label: row.label,
    }));
    setHolidayDates(formattedHolidayDates);
  }, [workingHolidaystable]); // Update holidayDates whenever workingHolidaystable changes

    const fetchProjectDetails = async () => {
        // To fetch project details of all projects - proj code, name, pm, status, date
        let selected_id = 0; // to fetch all project details
        try {
            const projdetails_url = `${BASEURL}/projects/${selected_id}/?orgid=${orgid}&userid=${userid}`;
            const response = await axios.get(projdetails_url, {
                headers: { Accept: 'application/json' },
            });

            // Correctly filter out projects with status 'Deleted'
            const project_dat = response.data.projects.filter((project: { project_status: string; }) => project.project_status !== 'Deleted');

            setProjectData(project_dat);
            setFilteredProject(project_dat);

        } catch (error) {
            console.log(error);
        }
    };

    // console.log("projectData:",projectData);

  const fetch_emp_contracts_names = async () => {
    try {
      const status_url = `${BASEURL}/users/emp_contractor_list?orgid=${orgid}`;
      const response = await axios.get(status_url, {
        headers: { Accept: 'application/json' },
      });

      const { employees, contractors } = response.data;
      setEmpNames(employees);

      //             console.log("Fetched Employees:", employees);
      //             console.log("Fetched Contractors:", contractors);

      const employeeData = employees.map((emp: any, index: number) => ({
        employeeId: index + 1, // or emp.id if available
        employeeName: emp.username,
      }));

      const contractorData = contractors.map((emp: any, index: number) => ({
        contractorsId: index + 1, // or emp.id if available
        contractorsName: emp.username,
      }));

      //             console.log("Employee Data for Dropdown:", employeeData);
      contractorSetNames(contractorData);
      setNames(employeeData);

      // Update columns with employee names
      columns.map((col: any) => {
        col.dropdownData = employeeData;
        return col;
      });

      //             // Store employee data in local storage
      localStorage.setItem('names', JSON.stringify(employeeData));
      localStorage.setItem('contractorsname', JSON.stringify(contractorData));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_emp_contracts_names();
    fetchWorkingdaysandHolidays();
  }, []); // Empty dependency array means this useEffect runs once on mount

  const rows = filteredProject.map((project, index) => ({
    projectcode: project.project_code,
    projectname: project.project_name,
    status: project.project_status,
    projectmanagers: project.project_manager,
    startdate: project.project_start_date,
    enddate: project.project_end_date,
    /*
        action: (
            <Button variant='contained' onClick={() => handleViewProject(project)}>
                View
            </Button>
        ),
        */
    action: (
      <Checkbox
        onChange={(event) => handleSelectProject(event, project)}
      ></Checkbox>
    ),
  }));

  const columns: Column[] = [
    { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'projectmanagers', label: 'Project Managers', align: 'left' },
    { id: 'startdate', label: 'Start Date', align: 'left' },
    { id: 'enddate', label: 'End Date', align: 'left' },
    { id: 'action', label: 'Select', align: 'left' },
  ];

  const handleSearch = () => {
    // Handle search logic
  };

  const handleViewProject = (project: Projects) => {
    // Navigate to project details page or perform other actions
    let projid = project.id;
    const projectsWithMatchingId = projectData.filter(
      (project) => project.id === projid
    );
    if (projectsWithMatchingId.length > 0) {
      const projectCode = projectsWithMatchingId[0].project_code;
      navigate('/viewSchedule', {
        state: {
          projectid: project.id,
          projectcode: project.project_code,
          projectname: project.project_name,
        },
      });
    }
  };

  const handleViewProjects = () => {
    if (selProjects && selProjects.length == 0)
      toast.error('Please select at least one project to view');
    else {
      setIsLoading(true);
      navigate('/viewSchedule', {
        state: { selectedProjects: selProjects, holidayDates: holidayDates },
      });
      setIsLoading(false);
    }
  };

  // console.log("selProjects:",selProjects)

  const handleSelectProject = (event: any, project: Projects) => {
    let projectId = -1;
    if (project.id != null) projectId = project.id;

    if (event.target.checked) {
      //Clone prev array and append selected project id to array
      const selectedProject = projectData.find(
        (project) => project.id === projectId
      );
      if (selectedProject) {
        // Add the selected project to selProjectIds
        setSelProjects((prevProjects) => [...prevProjects, selectedProject]);
      }
    } else {
      // Remove the project ID from the state array when checkbox unchecked.
      setSelProjects((prevProjects) =>
        prevProjects.filter((project) => project.id !== projectId)
      );
    }
  };

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = () => {
    setIsDialogOpen(true);
    handleMenuClose();
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setShowTextFields(false);
    setHolidaysRows([]); // Clear the holidays rows state
  };

  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  //Holiday table column
  const Holidayscolumns: Column[] = [
    { id: 'label', label: 'Label', align: 'left' },
    { id: 'date', label: 'Date', align: 'left' },
    { id: 'action', label: 'Action', align: 'center' },
  ];

  // In the code, map through the holidaysData to display it in the table
  const Holidaysrows = workingHolidaystable.map(
    (holiday: HolidayData, index: number) => ({
      label: holiday.label,
      date: holiday.date,
      action: (
        <Button
          variant='contained'
          color='primary'
          onClick={() => handleDelete(holiday)}
        >
          Delete
        </Button>
      ),
    })
  );

  const handleAddRow = () => {
    setShowTextFields(true);
    setHolidaysRows([...holidaysRows, { label: '', date: null }]);
  };

  const handleInputChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRows = [...holidaysRows];
    newRows[index].label = event.target.value;
    setHolidaysRows(newRows);
  };

  const handleDateChange = (index: number, date: Date | null) => {
    const newRows = [...holidaysRows];
    newRows[index].date = date;
    setHolidaysRows(newRows);
  };

  const handleDayClick = (day: string) => {
    setSelectedDays((prevDays) => {
      if (prevDays.includes(day)) {
        // If the day is already selected, remove it
        return prevDays.filter((d) => d !== day);
      } else {
        return [...prevDays, day];
      }
    });
  };

  const getButtonVariant = (day: string) => {
    return selectedDays.includes(day) ? 'contained' : 'outlined';
  };

  const getWorkWeek = () => {
    return selectedDays.join(',');
  };

  //Store the woorkweek data
  localStorage.setItem('getWorkWeek', JSON.stringify(getWorkWeek()));

  const handleSave = async () => {
    const hasEmptyFields = holidaysRows.some((row) => !row.label || !row.date);
    if (hasEmptyFields) {
      toast.error('Please fill both the label and date fields before saving');
      return;
    }
    // Combine previous and new entries
    const combinedHolidays = [
      ...workingHolidaystable,
      ...holidaysRows.map((row) => ({
        label: row.label,
        date: row.date ? format(row.date, 'yyyy-MM-dd') : '',
      })),
    ];

    // Format data for submission or further processing
    const holidayDates = combinedHolidays.map((row) => row.date).join(',');
    const holidayLabels = combinedHolidays.map((row) => row.label).join(',');

    // Format the data to be sent
    const formattedData = {
      holiday_date: holidayDates,
      holiday_label: holidayLabels,
      work_week: getWorkWeek(),
      holidaytracking_orgid: orgid,
    };

    try {
      // URL to send the data
      const create_url = BASEURL + '/add-workweek-holiday/';

      // Send data to backend
      const response = await axios.post(create_url, formattedData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.status === 'success') {
        toast.success(response.data.message);

        // Update the table with the new data
        setWorkingHolidaystable((prevRows) => [
          ...prevRows,
          ...holidaysRows.map((row) => ({
            label: row.label,
            date: row.date ? format(row.date, 'yyyy-MM-dd') : '',
          })),
        ]);
        setHolidaysRows([]);
        setShowTextFields(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error sending data to the backend:', error);
      toast.error('Error saving the data');
    }
  };

  //Function to delete the  holidays in the row.
  const handleDelete = async (holiday: HolidayData) => {
    try {
      const date = new Date(holiday.date);
      const formattedDate = date.toISOString().split('T')[0];

      // Replace with your API URL
      const delete_url = `${BASEURL}/delete-workweek-holiday/`;

      // Data to send to the backend
      const deleteData = {
        holiday_label: holiday.label,
        holiday_date: formattedDate,
        holidaytracking_orgid: orgid,
      };

      // Send delete request to backend
      const response = await axios.post(delete_url, deleteData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.status === 'success') {
        toast.success('Holiday deleted successfully');
        setWorkingHolidaystable((prevRows) =>
          prevRows.filter((row) => row !== holiday)
        );
      } else {
        toast.error('Failed to delete holiday');
      }
    } catch (error) {
      toast.error('Error deleting the holiday');
    }
  };

  

  const getButtonStyles = (day: string): SxProps<Theme> => {
    const isSelected = selectedDays.includes(day);
    return {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px',
      minWidth: '100px',
      backgroundColor: isSelected ? undefined : '#363537', // Non-working day button color
      color: isSelected ? undefined : '#FCFFF8', // Non-working day label color
      '&:hover': {
      backgroundColor: isSelected ? undefined : '#363537', // Ensure the button stays gray on hover if it's not selected
    },
    };
  };

  // const checkboxStyles = {
  //   color: pink[800],
  //   '&.Mui-checked': {
  //     color: pink[600],
  //   },
  // };
 const subscriptionstatus = organizationFinal?.organization?.organization_subscription_status;

 const isUserAdmin = (subscriptionstatus === 'Active') && (userRole === 'Admin' || scheduleAccess === 'Owner');
  return (
    <ThemeProvider theme={getTheme()}>
       {(subscriptionstatus === 'Active' || subscriptionstatus === 'Expired') ? ( 
        <Box>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Box sx={{ marginTop: '-60px' }}>
      {subscriptionstatus === 'Expired' && (
        <Typography variant="body1">
          <h3>Please renew your subscription.</h3>
        </Typography>
      )}
      </Box>
      <Box sx={{ marginTop: '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='h5' component='div'>
            Project Schedule
          </Typography>

          <Box sx={{ marginLeft: 'auto' }}>
          <Tooltip
                      title={
                        subscriptionstatus === 'Expired'
                          ? 'You do not have access to view the project schedule'
                          : ''
                      }
                      placement="top"
                      arrow
                    >
            <Button variant='contained' onClick={() => {if (subscriptionstatus === 'Active') {
              handleViewProjects()}}}
             sx={{
              mr: 1,
              opacity: subscriptionstatus === 'Expired' ? 0.5 : 1
            }}>
              View Schedule
            </Button>
            </Tooltip>
            {isUserAdmin && (
              <IconButton
                aria-label='more'
                aria-controls='long-menu'
                aria-haspopup='true'
                onClick={handleMenuClick}
                sx={{ marginLeft: 'auto' }}
              >
                <MoreVertIcon />
              </IconButton>
            )}
            <Menu
              id='long-menu'
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleOptionClick}>
                Set Working Days & Holidays
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      
        <Box sx={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
          <InputBase
            placeholder='Search…'
            inputProps={{ 'aria-label': 'search' }}
            sx={{
              marginRight: '10px',
              border: '1px solid',
              borderRadius: '4px',
              paddingLeft: '10px',
              ml: '5%',
              height: '45px',
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button variant='contained' onClick={handleSearch}>
            Search
          </Button>
        </Box>
        {/* Dialog for setting working days and holidays */}
        <Dialog
          open={isDialogOpen}
          onClose={handleDialogClose}
          maxWidth='lg'
          PaperProps={{
            style: {
              height: '600px',
              width: '900px',
            },
          }}
        >
          <DialogTitle  sx={{
    fontWeight: 'bold', // Increases font weight
    fontSize: '1.25rem', // Optional: You can also adjust the font size
  }}>
            Assign working days and holidays
            <IconButton
              aria-label='close'
              onClick={handleDialogClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flexWrap: 'wrap',
              }}
            >
              <Typography variant='h6'>Working Days</Typography>
              <Box sx={{ display: 'flex', gap: '0px', flexWrap: 'wrap' }}>
                {daysOfWeek.map((day, index) => (
                  <Button
                    key={index}
                    variant={getButtonVariant(day)}
                    onClick={() => handleDayClick(day)}
                    sx={getButtonStyles(day)}>
                   <div>{day}</div>
                   <Checkbox
            checked={selectedDays.includes(day)}
            onChange={() => handleDayClick(day)}
            sx={{
              color: pink[800],
              '&.Mui-checked': {
                color: pink[600],
              },
            }}
            defaultChecked
            style={{ pointerEvents: 'none' }} // Prevents the checkbox from being toggled independently of the button
          />
                  </Button>
                ))}
              </Box>
            </Box>
            <Box sx={{mt:"30px"}}>
              <Typography variant='h6'>Holidays</Typography>
              <Box sx={{ marginTop: '20px' }}>
                <BasicTable columns={Holidayscolumns} rows={Holidaysrows} />
                {/* Render the new row for input */}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {showTextFields && (
                    <Box>
                      {holidaysRows.map((holiday, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: 'flex',
                            gap: '16px',
                            marginTop: '10px',
                            ml: '45px',
                          }}
                        >
                          <TextField
                            label='Holiday Label'
                            name='label'
                            value={holiday.label}
                            onChange={(event: any) =>
                              handleInputChange(index, event)
                            }
                          />
                          <DatePicker
                            label='Holiday Date'
                            value={holiday.date}
                            onChange={(date) => handleDateChange(index, date)}
                            sx={{ width: '30%' }}
                          />
                        </Box>
                      ))}
                    </Box>
                  )}
                </LocalizationProvider>
              </Box>
            </Box>
            {/* Add any additional form or content here */}
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={handleAddRow} color='primary'>
              Add
            </Button>
            <Button variant='contained' onClick={handleSave} color='primary'>
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Box sx={{ marginTop: '20px' }}>
          <BasicTable columns={columns} rows={rows} />
        </Box>
        <FloatingButton />
      </Box>
      </Box>
     ):(subscriptionstatus === '' && <Typography variant="body1">
      <h3>Please purchase a subscription plan.</h3>
    </Typography>)} 
    </ThemeProvider>
  );
};

export default ProjectSchedule;